export const getGeoLocationObject = () => {
    const dt = new Date();
    return { M: {
            geo_acc: { N: "0" },
            geo_alt: { N: "0" },
            geo_gps_time: { N: Date.UTC(dt.getFullYear(), dt.getMonth()+1, dt.getDate()).toString() },
            geo_tablet_time: { N: Date.UTC(dt.getFullYear(), dt.getMonth()+1, dt.getDate()).toString() },
            geo_lat: { N: "" },
            geo_lon: { N: "" },
            geo_src: { S: "Client" },
            geo_utc: { S: dt.toUTCString() }
        }
    }
};